export const StringToDate = function (strDate: string) {
    let date = new Date();
    let hours = strDate.split(":")[0];
    let minutes = strDate.split(":")[1];
    let seconds = strDate.split(":")[2];
    date.setHours(+hours);
    date.setMinutes(+minutes);
    date.setSeconds(+seconds);
    return date.toISOString() !== '' ? date : '';
}